import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageValleiry: React.FC = () => (
  <LocalSeoPage
    city="Valleiry"
    slug="depannage-informatique-valleiry"
    metaTitle="Dépannage informatique Valleiry | Technicien PC local"
    metaDescription="Technicien informatique à Valleiry. Dépannage PC, Mac, virus, optimisation. Intervention rapide à domicile."
    intro="Votre ordinateur vous cause des soucis à Valleiry ? Un technicien informatique local intervient rapidement, à votre domicile. PC lent, virus, WiFi en panne ou Windows bloqué — on s'occupe de tout avec un diagnostic gratuit et un devis clair."
    postalCode="74520"
    cityFaqs={[
      { question: "Combien de temps pour une intervention à domicile à Valleiry ?", answer: "Valleiry est à une quinzaine de minutes au plus de Viry, déplacement inclus dans le tarif. La date dépend de notre planning : contactez-nous, nous vous proposons un créneau. Réponse en moins de 2h, 7j/7, intervention souvent le jour même." },
      { question: "Dépannez-vous aussi les Mac à Valleiry ?", answer: "Oui, nous dépannons les PC comme les Mac : lenteurs, virus, mises à jour bloquées, problèmes de connexion. Indiquez le modèle et le problème en prenant contact pour que nous préparions l'intervention." },
    ]}
    travelTime="une quinzaine de minutes au plus depuis Viry"
    nearbyTowns={[
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Vers' },
      { name: 'Feigères' },
      { name: 'Chênex' },
      { name: 'Andilly' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage PC à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique autour de Genève', href: '/depannage-informatique-geneve' },
    ]}
  />
);

export default DepannageValleiry;
